


























































import { Vue, Component } from 'vue-property-decorator'

@Component({})
export default class ResetPassword extends Vue {
  email = ''
  confirm = ''

  get disabled() {
    this.status = null
    return !(this.email.length > 0 && this.email == this.confirm)
  }

  status = null as null | 'ok' | 'error'

  async submit() {
    if (this.disabled) return
    try {
      const res = await this.$api
        .ky('password/reset/', {
          method: 'post',
          json: { email: this.email }
        })
        .json()
      this.status = 'ok'
    } catch {
      this.status = 'error'
    }
  }
}
